import { Component, EventEmitter, Output, Input, signal, WritableSignal, OnInit, effect } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FeedbackService } from '../../../../../shared/services/componentsServices/feedback.service';
import { givenFeedbackField, givenFeedbackModel, currentFeedbackModel } from '../../../../../shared/models/serviceModels/request/feedbackReq.model';
import { feedbackFormsData } from '../../../../../shared/models/serviceModels/response/feedbackRes.model';

@Component({
    selector: 'app-confirmation-module',
    standalone: true,
    imports: [CommonModule, FormsModule, DialogModule, FontAwesomeModule],
    templateUrl: './confirmation-module.component.html',
    styleUrl: './confirmation-module.component.scss'
})
export class ConfirmationModuleComponent implements OnInit {

  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();
  @Input() isVisible!: WritableSignal<boolean>;
  
  private givenFeedbackResponse: currentFeedbackModel| null  = null;

  summaryData: givenFeedbackField[] | null= null;
  highlightedsummaryData: givenFeedbackField[] | null= null;
  private feedbackFormData: feedbackFormsData | null = null;

  hasFeedbackData: boolean = false;
  hasHighlightedData: boolean = false;
 
  private feedbackType: string = '';

  constructor(library: FaIconLibrary, private feedbackService: FeedbackService) {
    library.addIconPacks(fas);
    effect(() => {
      if (this.isVisible()) {

        this.cleanMappedData();
        // this.feedbackService.resetFeedbackValues();

        this.getFeedbackFormData();
        this.getFeedbackSummary();
        this.getFeedbackType();
        this.mapSummaryForUi();

        let test= this.hasHighlightedData;
      }
    });
  }
 

  ngOnInit(): void {
  
  }

  getFeedbackFormData() {
    let feedbackFormData= this.feedbackService.getFormData()();
    if(feedbackFormData){
      this.feedbackFormData= feedbackFormData;
    }
  }

  getFeedbackType() {

    let selectedType = this.feedbackService.getSelectedFeedbackType();

    if(selectedType !== null){
      this.feedbackType= selectedType.field ?? '';
    }
 
  }
  

  mapCurrentFieldDescription(value: string): string{
    let currentFieldDescription="";

    switch(value) {
      case "scenario":
        currentFieldDescription="Scenario";
        break;

      case "scenario_name":
        currentFieldDescription="Scenario name";
        break;

      case "predicted_price":
        currentFieldDescription="Predicted Price";
        break;
      case "contract":
        currentFieldDescription="Contract";
        break;
      case "direction":
        currentFieldDescription="Direction";
        break;
      case "lots":
        currentFieldDescription="Lots quantity";
        break;  
      case "trade_price":
        currentFieldDescription="Trade Price";
        break;
      case "free_text":
        currentFieldDescription="Additional Comments";
        break;
      case "tradeDate":
        currentFieldDescription="Trade Date";
        break;
      case "runDate":
        currentFieldDescription="Prediction Run Date";
        break;  
      default:
        currentFieldDescription=value;
  }
  return currentFieldDescription;
}

  setOrderForShowing(value: string): number{
    let orderForShowing=99;

    switch(value) {
      case "scenario":
        orderForShowing = 12;
        break;

      // case "predicted_price":
      //   orderForShowing = 2;
      //   break;
      case "contract":
        orderForShowing = 15;
        break;
      case "direction":
        orderForShowing = 18;
        break;
      case "lots":
        orderForShowing = 17;
        break;  
      // case "trade_price":
      //   orderForShowing = 4;
      //   break;
      case "free_text":
        orderForShowing = 98;
        break;
      // case "trade_date":
      //   orderForShowing = 14;
      //   break;
      // case "run_date":
      //   orderForShowing = 11;
      //   break;  
      default:
        orderForShowing = 97;
    
  }
  return orderForShowing;
}


  formatValue(value: string, fieldName: string, extraDescription?:string): string {

    let returnedValue= value;

    if(fieldName==="contract"){
      const [monthStr, year] = value.split("-");
      const monthIndex = parseInt(monthStr, 10) - 1;

      if (isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11 || !year) {
        return value; 
      }

      const date = new Date(2000, monthIndex); 
      const monthName = date.toLocaleString('en-US', { month: 'long' });

      returnedValue= `${monthName} ${year}`;
    }

    if(fieldName==="scenario"){
      returnedValue= extraDescription?? value;
    }

    if(fieldName==="direction"){
      let textDirection = this.feedbackFormData?.directions?.feedbackFieldValues?.find(item => item.id?.toString() === value)?.field ?? value;
      returnedValue= textDirection;
    }

    return returnedValue;
  }

  formatDate(currentdate: Date): string {
    let formatedDate= new Date(currentdate).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });

    return formatedDate;
  }

  mapFeedbackFieldEntries(currentData: givenFeedbackField[]){

    let itemsList: givenFeedbackField[] = [];

    currentData.forEach(item => {
      let currentFieldDescription= this.mapCurrentFieldDescription(item.fieldName);
      let currentOrder= this.setOrderForShowing(item.fieldName);
      
      let currentItem: givenFeedbackField = {
        dataTypeId: item.dataTypeId,
        fieldId: item.fieldId,
        fieldName: item.fieldName,
        value: this.formatValue(item.value, item.fieldName, item.extraDescription),
        // value: item.value,
        fieldDescription: currentFieldDescription,
        order: currentOrder,
        isHighlighted: item.isHighlighted
        // isHighlighted: this.getIsHighlightedFlag(item.fieldName)
      }

      if(currentItem.fieldName !== "predicted_price" && currentItem.fieldName !== "trade_price"){
        itemsList.push(currentItem);
      }

      // itemsList.push(currentItem);
      
    })

    this.setSummaryData(itemsList);

  }

  setHighlightedsummaryData(){
 
      
    if(this.highlightedsummaryData && this.highlightedsummaryData.length>0){
      this.hasHighlightedData=true;
      this.highlightedsummaryData.sort((a, b) => (a.order ?? 99) - (b.order ?? 99));
    }

  }

  setSummaryData(currentItems:givenFeedbackField[]){
    let valuesForShowing: givenFeedbackField[] = [];

    currentItems.forEach(item => {
      if (!item.isHighlighted) {
        valuesForShowing.push(item);
      } 
    });

    valuesForShowing.sort((a, b) => (a.order ?? 99) - (b.order ?? 99));

    this.summaryData = valuesForShowing;
  }

  updateDirectionDescription(item: givenFeedbackField): givenFeedbackField{
    let updatedDirection: givenFeedbackField = {
      ...item,
      value: this.formatValue(item.value, item.fieldName)
      // value: this.feedbackFormData?.directions?.feedbackFieldValues?.find(dir => dir.id?.toString() === item.value)?.field ?? item.value
    }
    return updatedDirection;
  }

  updateContractDescription(item: givenFeedbackField): givenFeedbackField{
    let updatedContract: givenFeedbackField = {
      ...item,
      value: this.formatValue(item.value, item.fieldName)
      // value: this.feedbackFormData?.directions?.feedbackFieldValues?.find(dir => dir.id?.toString() === item.value)?.field ?? item.value
    }
    return updatedContract;
  }

  mapInitiateCloseFeedback(){
    let currentFeedback= this.givenFeedbackResponse;
    let currentData = this.givenFeedbackResponse?.feedbackFields ? 
      JSON.parse(JSON.stringify(this.givenFeedbackResponse.feedbackFields)) : null;

    let highlightedData: givenFeedbackField[] = [];

    let tradeDateField: givenFeedbackField | null = currentFeedback?.tradeDate ? {
      dataTypeId: 0,
      fieldId: 0,
      fieldName: "tradeDate",
      value: currentFeedback?.tradeDate ? this.formatDate(currentFeedback?.tradeDate) : '',
      fieldDescription: "Trade date",
      order: 3,
      isHighlighted: true}: null;

    // let tradePrice= currentFeedback?.feedbackFields?.find(item => item.fieldName == "trade_price")?.value?.toString() ?? '';
      
    let tradeEntryPriceField: givenFeedbackField | null = currentFeedback?.closingTradeData?.tradeEntryPrice ? {
      dataTypeId: 0,
      fieldId: 0,
      fieldName: "tradePrice",
      value: `$ ${currentFeedback?.closingTradeData?.tradeEntryPrice ? currentFeedback?.closingTradeData?.tradeEntryPrice.toString() : ''}`,
      fieldDescription: "Trade price",
      order: 4,
      isHighlighted: true
  } : null;

    let closeDateField: givenFeedbackField | null = currentFeedback?.closingTradeData?.closingDate ? {
        dataTypeId: 0,
        fieldId: 0,
        fieldName: "closingDate",
        value: currentFeedback?.closingTradeData?.closingDate ? this.formatDate(currentFeedback?.closingTradeData?.closingDate) : '',
        fieldDescription: "Closing date",
        order: 5,
        isHighlighted: true
    } : null;

    let closingPriceField: givenFeedbackField | null = currentFeedback?.closingTradeData?.closingPrice ? {
      dataTypeId: 0,
      fieldId: 0,
      fieldName: "closingPrice",
      value: `$ ${currentFeedback?.closingTradeData?.closingPrice ? currentFeedback?.closingTradeData?.closingPrice.toString() : ''}`,
      fieldDescription: "Closing price",
      order: 6,
      isHighlighted: true
  } : null;

  if(currentFeedback?.predictionRunDate){
    let runDateField: givenFeedbackField | null = {
        dataTypeId: 0,
        fieldId: 0,
        fieldName: "runDate",
        value: currentFeedback?.predictionRunDate ? this.formatDate(currentFeedback?.predictionRunDate) : '',
        fieldDescription: "Run date",
        order: 1,
        isHighlighted: true
    }
  
    // if(currentFeedback?. ){}
  
    let priceValue = currentFeedback?.feedbackFields?.find(item => item.fieldName == "predicted_price")?.value?.toString() ?? '';
  
    if(priceValue && priceValue!=='' && priceValue!=='0'){
      let predictionPriceField: givenFeedbackField | null = {
        dataTypeId: 0,
        fieldId: 0,
        fieldName: "predictedPrice",
        value: `$ ${priceValue}`,	
        fieldDescription: "Predicted price",
        order: 2,
        isHighlighted: true
      }
  
      highlightedData.push(predictionPriceField);
    }
  
    highlightedData.push(runDateField);
  
  }

    highlightedData.push(tradeDateField!);
    highlightedData.push(tradeEntryPriceField!);
    
    highlightedData.push(closeDateField!);
    highlightedData.push(closingPriceField!);

    this.highlightedsummaryData = highlightedData;
    this.setHighlightedsummaryData();

    let summaryExtraFields= this.getInitiateCloseFields(currentData!, currentFeedback!);

    // this.mapFeedbackFieldEntries(currentData ?? []);
    this.mapFeedbackFieldEntries(summaryExtraFields ?? []);

  }

  // formatValue(value: string, fieldName: string, extraDescription?:string)

  mapCloseTradeFeedback(){
    let currentFeedback= this.givenFeedbackResponse;
    let currentData = this.givenFeedbackResponse?.feedbackFields ? 
      JSON.parse(JSON.stringify(this.givenFeedbackResponse.feedbackFields)) : null;
    
    let highlightedData: givenFeedbackField[] = [];

    let tradeDateField: givenFeedbackField | null = currentFeedback?.closingTradeData?.tradeDate ? {
      dataTypeId: 0,
      fieldId: 0,
      fieldName: "tradeDate",
      value: currentFeedback?.closingTradeData?.tradeDate ? this.formatDate(currentFeedback?.closingTradeData?.tradeDate) : '',
      fieldDescription: "Trade date",
      order: 1,
      isHighlighted: true}: null;

    let tradeEntryPriceField: givenFeedbackField | null = currentFeedback?.closingTradeData?.tradeEntryPrice ? {
      dataTypeId: 0,
      fieldId: 0,
      fieldName: "tradePrice",
      value: `$ ${currentFeedback?.closingTradeData?.tradeEntryPrice ? currentFeedback?.closingTradeData?.tradeEntryPrice.toString() : ''}`,
      fieldDescription: "Trade price",
      order: 2,
      isHighlighted: true
  } : null;

    let closeDateField: givenFeedbackField | null = currentFeedback?.closingTradeData?.closingDate ? {
        dataTypeId: 0,
        fieldId: 0,
        fieldName: "closingDate",
        value: currentFeedback?.closingTradeData?.closingDate ? this.formatDate(currentFeedback?.closingTradeData?.closingDate) : '',
        fieldDescription: "Closing date",
        order: 3,
        isHighlighted: true
    } : null;

    let closeingPriceField: givenFeedbackField | null = currentFeedback?.closingTradeData?.closingPrice ? {
      dataTypeId: 0,
      fieldId: 0,
      fieldName: "closingPrice",
      value: `$ ${currentFeedback?.closingTradeData?.closingPrice ? currentFeedback?.closingTradeData?.closingPrice.toString() : ''}`,
      fieldDescription: "Closing price",
      order: 4,
      isHighlighted: true
  } : null;

    highlightedData.push(tradeDateField!);
    highlightedData.push(tradeEntryPriceField!);
    
    highlightedData.push(closeDateField!);
    highlightedData.push(closeingPriceField!);

    this.highlightedsummaryData = highlightedData;
    this.setHighlightedsummaryData();

  

    let summaryExtraFields= this.getExtraFields(currentData!, currentFeedback!);

    // this.mapFeedbackFieldEntries(currentData ?? []);
    this.mapFeedbackFieldEntries(summaryExtraFields ?? []);
   
  }

  getClosingReasonText(reasonId: number): string{
    let reasonText= this.feedbackFormData?.closingReasons?.feedbackFieldValues?.find(item => item.id ===reasonId)?.description ?? '';
    return reasonText;
  }

  getInitiateCloseFields(currentData: givenFeedbackField[], currentFeedback: currentFeedbackModel):givenFeedbackField[]{
    let extraFields: givenFeedbackField[] = [];

    let closingReason: givenFeedbackField | null = currentFeedback?.closingTradeData?.closingReasonId ? {
      dataTypeId: 0,
      fieldId: 0,
      fieldName: "Closing reason",
      // fieldName: "closingReason",
      value:  this.getClosingReasonText(currentFeedback?.closingTradeData?.closingReasonId) ,
      fieldDescription: "closingReason",
      order: 5,
      isHighlighted: false
  } : null;

  extraFields.push(closingReason!);

  let contractValue= currentFeedback?.closingTradeData?.tradeContract ? this.formatValue(currentFeedback?.closingTradeData?.tradeContract, "contract") : '';

  let contract: givenFeedbackField | null = currentFeedback?.closingTradeData?.tradeContract ? {
    dataTypeId: 0,
    fieldId: 0,
    fieldName: "Contract",
    value:  contractValue,
    // value:  currentFeedback?.closingTradeData?.tradeContract ? currentFeedback?.closingTradeData?.tradeContract : '',
    fieldDescription: "tradeContract",
    order: 6,
    isHighlighted: false
  } : null;

  extraFields.push(contract!);

  let directionValue= currentFeedback?.closingTradeData?.tradeDirection ? this.formatValue(currentFeedback?.closingTradeData?.tradeDirection, "direction") : '';

  let direction: givenFeedbackField | null = currentFeedback?.closingTradeData?.tradeDirection ? {
      dataTypeId: 0,
      fieldId: 0,
      fieldName: "Direction",
      value:  directionValue,
      // value:  currentFeedback?.closingTradeData?.tradeDirection ? currentFeedback?.closingTradeData?.tradeDirection : '',
      fieldDescription: "tradeDirection",
      order: 7,
      isHighlighted: false
  } : null;
  extraFields.push(direction!);

  let lots: givenFeedbackField | null = currentFeedback?.closingTradeData?.tradeLots ? {
      dataTypeId: 0,  
      fieldId: 0, 
      fieldName: "Lots quantity",
      value:  currentFeedback?.closingTradeData?.tradeLots ? currentFeedback?.closingTradeData?.tradeLots.toString() : '',
      fieldDescription: "tradeLots",
      order: 8,
      isHighlighted: false
  } : null;


  extraFields.push(lots!);

  // currentData.forEach(item => {
  //   if (item.fieldName === "free_text") {
  //     item.fieldName = "Additional Comments";
  //   }
  // });

  let freeText: givenFeedbackField | null = currentData.find(item => item.fieldName === "free_text") ?? null;
  if(freeText){
    freeText.fieldName= "Additional Comments";
    extraFields.push(freeText!);
  }
 
  

  // extraFields = extraFields.concat(currentData);

  


    return extraFields;
  }

  getExtraFields(currentData: givenFeedbackField[], currentFeedback: currentFeedbackModel):givenFeedbackField[]{
    let extraFields: givenFeedbackField[] = [];

    //buscar texto en maestro de reasons
    let closingReason: givenFeedbackField | null = currentFeedback?.closingTradeData?.closingReasonId ? {
      dataTypeId: 0,
      fieldId: 0,
      fieldName: "Closing reason",
      // fieldName: "closingReason",
      value:  this.getClosingReasonText(currentFeedback?.closingTradeData?.closingReasonId) ,
      fieldDescription: "closingReason",
      order: 5,
      isHighlighted: false
  } : null;

  extraFields.push(closingReason!);

  let contractValue= currentFeedback?.closingTradeData?.tradeContract ? this.formatValue(currentFeedback?.closingTradeData?.tradeContract, "contract") : '';

  let contract: givenFeedbackField | null = currentFeedback?.closingTradeData?.tradeContract ? {
    dataTypeId: 0,
    fieldId: 0,
    fieldName: "Contract",
    value:  contractValue,
    // value:  currentFeedback?.closingTradeData?.tradeContract ? currentFeedback?.closingTradeData?.tradeContract : '',
    fieldDescription: "tradeContract",
    order: 6,
    isHighlighted: false
  } : null;

  extraFields.push(contract!);

  let directionValue= currentFeedback?.closingTradeData?.tradeDirection ? this.formatValue(currentFeedback?.closingTradeData?.tradeDirection, "direction") : '';

  let direction: givenFeedbackField | null = currentFeedback?.closingTradeData?.tradeDirection ? {
      dataTypeId: 0,
      fieldId: 0,
      fieldName: "Direction",
      value:  directionValue,
      // value:  currentFeedback?.closingTradeData?.tradeDirection ? currentFeedback?.closingTradeData?.tradeDirection : '',
      fieldDescription: "tradeDirection",
      order: 7,
      isHighlighted: false
  } : null;
  extraFields.push(direction!);

  let lots: givenFeedbackField | null = currentFeedback?.closingTradeData?.tradeLots ? {
      dataTypeId: 0,  
      fieldId: 0, 
      fieldName: "Lots quantity",
      value:  currentFeedback?.closingTradeData?.tradeLots ? currentFeedback?.closingTradeData?.tradeLots.toString() : '',
      fieldDescription: "tradeLots",
      order: 8,
      isHighlighted: false
  } : null;


  extraFields.push(lots!);

  currentData.forEach(item => {
    if (item.fieldName === "free_text") {
      item.fieldName = "Additional Comments";
    }
  });

  

  extraFields = extraFields.concat(currentData);

  

  return extraFields;
  }

  mapInitateTradeFeedback(){ 

    let currentFeedback= this.givenFeedbackResponse;
    let currentData= this.givenFeedbackResponse?.feedbackFields ? 
                      JSON.parse(JSON.stringify(this.givenFeedbackResponse.feedbackFields)) : null;
    // let currentData= this.givenFeedbackResponse?.feedbackFields;

    
    let highlightedData: givenFeedbackField[] = [];


    if(currentFeedback?.tradeDate){
      let tradeDateField: givenFeedbackField | null = {
          dataTypeId: 0,
          fieldId: 0,
          fieldName: "tradeDate",
          value: currentFeedback?.tradeDate ? this.formatDate(currentFeedback?.tradeDate) : '',
          fieldDescription: "Trade date",
          order: 3,
          isHighlighted: true
      }

      highlightedData.push(tradeDateField);


      let tradeEntryPriceField: givenFeedbackField | null = {
        dataTypeId: 0,
        fieldId: 0,
        fieldName: "tradePrice",
        value: `$ ${currentFeedback?.feedbackFields?.find(item => item.fieldName == "trade_price")?.value?.toString() ?? ''}`,
        fieldDescription: "Trade price",
        order: 4,
        isHighlighted: true
      }

        highlightedData.push(tradeEntryPriceField!);
    }


    if(currentFeedback?.predictionRunDate){
      let runDateField: givenFeedbackField | null = {
          dataTypeId: 0,
          fieldId: 0,
          fieldName: "runDate",
          value: currentFeedback?.predictionRunDate ? this.formatDate(currentFeedback?.predictionRunDate) : '',
          fieldDescription: "Run date",
          order: 1,
          isHighlighted: true
      }

      // if(currentFeedback?. ){}

      let priceValue = currentFeedback?.feedbackFields?.find(item => item.fieldName == "predicted_price")?.value?.toString() ?? '';

      if(priceValue && priceValue!=='' && priceValue!=='0'){
        let predictionPriceField: givenFeedbackField | null = {
          dataTypeId: 0,
          fieldId: 0,
          fieldName: "predictedPrice",
          value: `$ ${priceValue}`,	
          fieldDescription: "Predicted price",
          order: 2,
          isHighlighted: true
        }

        highlightedData.push(predictionPriceField);
      }

      highlightedData.push(runDateField);
    
    }


    this.highlightedsummaryData =  highlightedData;
    // this.highlightedsummaryData = {...this.highlightedsummaryData, ...highlightedData};
    this.setHighlightedsummaryData();

    this.mapFeedbackFieldEntries(currentData ?? []);

  }

  getCurrentFedebackType(){

    let currentFeedbackId= this.givenFeedbackResponse?.feedbackTypeId ?? 0;

    let feedbackType = this.feedbackFormData?.feedbackType?.feedbackFieldValues?.find(item => item.id === currentFeedbackId)?.field?.toLowerCase() ?? '';

    return feedbackType;

  }

  mapSummaryForUi() {

    let currentType= this.getCurrentFedebackType();
    // let currentType= this.feedbackType.toLowerCase();

    switch(currentType) {
      case "initiate":
        this.mapInitateTradeFeedback();
        break;
      case "close":
        this.mapCloseTradeFeedback();
        break;
      case "initiate_close":
          this.mapInitiateCloseFeedback();
          break;
      default:
        this.mapInitateTradeFeedback();
    }
 
  }

  getIsHighlightedFlag(fieldname: string): boolean{
    let isHighlightedFlag= false;

    if(fieldname==="predicted_price" || fieldname==="trade_price" ){
      isHighlightedFlag=true;
    }

    return isHighlightedFlag;
  }

  getFeedbackSummary() {  

    let currentFeedback = this.feedbackService.getFeedbackBeforeSubmit();
  
    this.givenFeedbackResponse = currentFeedback;

    if (this.givenFeedbackResponse && this.givenFeedbackResponse.feedbackFields.length > 0) {
      this.hasFeedbackData=true;
     
    }
  }

  onCloseModal() {
    this.cleanMappedData();
    this.isVisible.set(false);
    this.close.emit();
  } 

  onSubmitForm() {
    this.isVisible.set(false);
    this.confirm.emit();
  }

  cleanMappedData(){
    this.summaryData= null;
    this.highlightedsummaryData= null;
    this.hasFeedbackData= false;
    this.hasHighlightedData= false;
  }

}
